function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.88392 8.00002L15.8169 1.06697C16.061 0.822881 16.061 0.427132 15.8169 0.18307C15.5728 -0.0609921 15.1771 -0.0610233 14.933 0.18307L7.99999 7.11612L1.06697 0.18307C0.822881 -0.0610233 0.427132 -0.0610233 0.18307 0.18307C-0.060992 0.427163 -0.0610233 0.822912 0.18307 1.06697L7.11608 7.99999L0.18307 14.933C-0.0610233 15.1771 -0.0610233 15.5729 0.18307 15.8169C0.305101 15.939 0.465069 16 0.625037 16C0.785006 16 0.944943 15.939 1.06701 15.8169L7.99999 8.88393L14.933 15.8169C15.055 15.939 15.215 16 15.375 16C15.5349 16 15.6949 15.939 15.8169 15.8169C16.061 15.5729 16.061 15.1771 15.8169 14.933L8.88392 8.00002Z"
});

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7102dff5.svg";
export { ForwardRef as ReactComponent };